export const CREATE_INDUSTRY_TYPE  = 'CREATE_INDUSTRY_TYPE';
export const GET_INDUSTRY_TYPES  = 'GET_INDUSTRY_TYPES';
export const INDUSTRY_TYPE_REQUEST  = 'INDUSTRY_TYPE_REQUEST';
export const DELETE_INDUSTRY_TYPE  = 'DELETE_INDUSTRY_TYPE';
export const UPDATE_INDUSTRY_TYPE  = 'UPDATE_INDUSTRY_TYPE';
export const INDUSTRY_TYPE_REQUEST_FAILURE  = 'INDUSTRY_TYPE_REQUEST_FAILURE';